import React, { useState, useEffect } from "react";
import { useSettings } from "../../../context/settingsContext";
import { Form, Input, Card, Spin, Button, message } from "antd";
import axios from "../../../context/axiosConfig";

const Banks = () => {
	const { settings, loading } = useSettings();
	const [bankData, setBankData] = useState({
		rachu_obc: "",
		bank_name: "",
		przekaz_destination_account: "",
		przekaz_destination_name: "",
	});
	const [isFormChanged, setIsFormChanged] = useState(false);

	useEffect(() => {
		if (settings && !loading) {
			console.log(settings);
			setBankData({
				rachu_obc: settings?.rachu_obc?.msr_settings_value || "",
				bank_name: settings?.bank_name?.msr_settings_value || "",
				przekaz_destination_account:
					settings?.przekaz_destination_account?.msr_settings_value ||
					"",
				przekaz_destination_name:
					settings?.przekaz_destination_name?.msr_settings_value ||
					"",
			});
		}
	}, [settings, loading]);

	useEffect(() => {
		if (settings) {
			const hasChanges =
				bankData.rachu_obc !==
					(settings?.rachu_obc?.msr_settings_value || "") ||
				bankData.bank_name !==
					(settings?.bank_name?.msr_settings_value || "") ||
				bankData.przekaz_destination_account !==
					(settings?.przekaz_destination_account
						?.msr_settings_value || "") ||
				bankData.przekaz_destination_name !==
					(settings?.przekaz_destination_name?.msr_settings_value ||
						"");
			setIsFormChanged(hasChanges);
		}
	}, [bankData, settings]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setBankData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async () => {
		try {
			await axios.post("/settings/update", bankData);
			message.success("Dane bankowe zostały zaktualizowane");
			setIsFormChanged(false);
		} catch (error) {
			message.error("Wystąpił błąd podczas aktualizacji danych");
		}
	};

	if (loading) {
		return <Spin />;
	}

	return (
		<Card>
			<Form layout="vertical">
				<Form.Item label="Rachunek obciążeniowy">
					<Input
						name="rachu_obc"
						value={bankData.rachu_obc}
						onChange={handleChange}
					/>
				</Form.Item>
				<Form.Item label="Nazwa banku">
					<Input
						name="bank_name"
						value={bankData.bank_name}
						onChange={handleChange}
					/>
				</Form.Item>
				<Form.Item label="Rachunek docelowy przekazów">
					<Input
						name="przekaz_destination_account"
						value={bankData.przekaz_destination_account}
						onChange={handleChange}
						placeholder="np. PLxx..."
					/>
				</Form.Item>
				<Form.Item label="Nazwa odbiorcy przekazów">
					<Input
						name="przekaz_destination_name"
						value={bankData.przekaz_destination_name}
						onChange={handleChange}
						placeholder="np. Marshal ..."
					/>
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						onClick={handleSubmit}
						disabled={!isFormChanged}
					>
						Zapisz zmiany
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
};

export default Banks;
